<template>
    <div class="items-content">
        <div class="title">{{ detail.title }}</div>
        <div v-for="item in detail.mobileChildren || detail.children" :key="item.id" class="wrap">
            <img
                v-if="item.cover && item.cover.url"
                :src="item.cover && item.cover.url"
                :alt="item.cover && (item.cover.caption || item.cover.alternativeText || item.cover.url)"
            />
            <div :class="['content', 'ck-content']" v-html="item.content"></div>
        </div>
    </div>
</template>

<script>
import ajax from '@/api/ajax'
export default {
    name: 'ContentComponent',
    components: {},
    data() {
        return {
            detail: {}
        }
    },
    computed: {},
    async created() {
        this.$route.meta.cmsApi &&
            ajax[this.$route.meta.cmsApi]().then(res => {
                this.detail = res
            })
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
.items-content {
    .title {
        font-size: 0.44rem;
        color: #333333;
        font-weight: bold;
        text-align: center;
        margin: 0.6rem 0;
        background-color: #fff;
    }
    .wrap {
        margin-bottom: 0.6rem;
        &:last-child {
            margin-bottom: 0;
        }
        .content {
            position: relative;
            background: #f1f1f1;
            padding: 0.2rem;
            >>> h2 {
                font-size: 0.34rem;
            }
        }
        .no-padding {
            padding: 0;
        }
        img {
            display: block;
            max-width: 100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/about-sf/content.vue